module.exports = __webpack_public_path__ + "static/img/1000000473_red.42baa82b.jpg";